import { api } from "../configs/axiosConfigs";

const trackReferral = async (data) => {
  const response = await api.request({
    url: "api/referral/track",
    method: "POST",
    data,
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

const attachRegistration = async (data) => {
  const response = await api.request({
    url: "api/referral/attach-registration",
    method: "POST",
    data,
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

const ReferralApi = {
  trackReferral,
  attachRegistration,
};

export default ReferralApi;
